
import React, { useEffect, useState } from "react";
import { Table, Form, Button, Space, Row, Col, Tooltip, Input } from "antd";
import "../Pages/CSS/DonnesBases.css";
import { GestionPaieService } from "../Services/GestionPaieService";
import { DeleteFilled } from "@ant-design/icons";

const TypePrets = () => {
  const [form] = Form.useForm();
  const [editing, setEditing] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10)
  const gestionPaieService = new GestionPaieService();

  const userProfil = localStorage.getItem("profil");
  const fetchAllData = async () => {
    try {
      const modelisation = await gestionPaieService.getAllTypePrets();
      setTableData(modelisation);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  useEffect(() => {
    fetchAllData();

  }, []);


  const handleUpdate = async () => {
    // Récupérer les valeurs actuelles du formulaire
    const values = await form.validateFields();

    const payload = {
      code: values.code,
      libelle: values.libelle,
    };

    try {
      const updatedData = await gestionPaieService.updateTypePrets(payload);
      // Mettre à jour les données du tableau avec les nouvelles données
      const updatedTableData = tableData.map((item) => {
        if (item.code === payload.code && item.libelle === payload.libelle) {
          return { ...item, ...updatedData };
        }
        return item;
      });
      setTableData(updatedTableData);
      await fetchAllData();
      setEditing(false);
      form.resetFields();
    } catch (error) {
      console.error('Erreur lors de la mise à jour :', error);
    }
  };

  const handleAddModelisation = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        code: values.code,
        libelle: values.libelle,
      };

      const response = await gestionPaieService.addTypePrets(payload);
      //   setTableData(response);
      await fetchAllData();
      setEditing(false);
      form.resetFields();
    } catch (error) {
      console.error('Erreur lors de la validation ou de l’ajout de données :', error);
      // Pas besoin de lancer d'autres logiques, car form.validateFields() a échoué
    }
  };



  const handleDelete = async (code) => {
    try {
      await gestionPaieService.deleteTypePrets(code);
      // Rafraîchir les données après la suppression
      await fetchAllData();
      form.resetFields();
      setEditing(false);
    } catch (error) {
      console.error('Erreur lors de la suppression :', error);
    }
  };




  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => a.code.localeCompare(b.code),
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => a.libelle.localeCompare(b.libelle),
    },
    ...(userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5'
      ? [
        {
          title: (
            <div
              style={{
                backgroundColor: "#010f1c",
                color: "white",
                padding: "1px",
              }}
            ></div>
          ),
          align: "center",
          fixed: "right",
          render: (text, record) => (
            <span>
              <Tooltip title="Supprimer">
                <DeleteFilled
                  style={{ cursor: "pointer", color: "red" }}
                  onClick={() => handleDelete(record.code)}
                />
              </Tooltip>
            </span>
          ),
        },
      ]
      : []),
  ].filter((column) => column);

  const onRowClick = (record) => {
    form.setFieldsValue({
      code: `${record.code}`,
      libelle: `${record.libelle}`,

    });
    setEditing(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setEditing(false);
  };

  return (
    <div>
      {userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5' && (
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            {/* <Col span={6}>
          <Form.Item
              name="code"
              label="Code"
              rules={[
                { required: true, message: "Le code est obligatoire" },
                
              ]}
            >
              <Input
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
              />
            </Form.Item>
          </Col> */}
            <Col span={6}>
              <Form.Item
                name="libelle"
                label="Libellé"
                rules={[
                  { required: true, message: "Le libellé est obligatoire" },

                ]}
              >
                <Input
                  bordered={false}
                  style={{ borderBottom: "2px solid #030303" }}
                />
              </Form.Item>
            </Col>

            <Col span={12} style={{ display: "flex", justifyContent: "right" }}>
              {editing ? (
                <Space>
                  <Button
                    style={{ marginTop: 10 }}
                    type="primary"
                    onClick={handleUpdate}
                    htmlType="submit"
                  >
                    Modifier
                  </Button>
                  <Button style={{ marginTop: 10 }} onClick={handleCancel}>
                    Annuler
                  </Button>
                </Space>
              ) : (
                <Space>
                  <Button
                    style={{ marginTop: 10 }}
                    type="primary"
                    htmlType="submit"
                    onClick={handleAddModelisation}
                  >
                    Enregistrer
                  </Button>
                </Space>
              )}
            </Col>
          </Row>
        </Form>
      )}
      <Table
        dataSource={tableData}
        columns={columns}
        scroll={{
          x: true,
        }}
        showSorterTooltip={false}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header1-table"
        bordered
        onRow={(record) => ({
          onClick: () => onRowClick(record),
        })}
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
      />
    </div>
  );
};

export default TypePrets;
